
import Vue from 'vue'

type DataType = {
  dragging: boolean;
}

export default Vue.extend({
  name: 'BaseFileDropArea',

  data(): DataType {
    return {
      dragging: false
    }
  },

  computed: {
    dropAreaClassText(): string {
      return this.dragging ? 'dragging' : ''
    }
  },

  methods: {
    dragenter(): void {
      this.dragging = true
    },

    dragleave(): void {
      this.dragging = false
    },

    drop(e: DragEvent): void {
      this.dragging = false
      this.$emit('selected', e?.dataTransfer?.files)
    }
  }
})
